import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'

const { unit } = measures

export const wrapper = css`
  width: ${38 * unit}px;
  height: ${4 * unit}px;
  background: #76768040;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const wrapperButton = css`
  width: ${19 * unit}px;
  height: ${4 * unit}px;
  border-radius: 6px;
  background: inherit;
  border: none;
  transition: none;
  :hover {
    background: ${colors.greens.green1};
    border-color: ${colors.greens.green1};
  }
`
export const wrapperButtonActive = css`
  width: ${19 * unit}px;
  height: ${4 * unit}px;
  border-radius: 6px;
  background: ${colors.greens.green1};
  border-color: ${colors.greens.green1};
  transition: none;
  :hover {
    background: ${colors.greens.green1};
    border-color: ${colors.greens.green1};
  }
`
